export const locales = [
  {
    id: 3,
    title: 'English',
    value: 'en',
    href: '/en',
  },
  {
    id: 5,
    title: 'Deutsch',
    value: 'de_DE',
    href: '/de_DE',
  },
  {
    id: 6,
    title: 'Français (France)',
    value: 'fr_FR',
    href: '/fr_FR',
  },
  {
    id: 1187,
    title: 'Français (Canada)',
    value: 'fr_CA',
    href: '/fr_CA',
  },
  {
    id: 7,
    title: 'Español (España)',
    value: 'es_ES',
    href: '/es_ES',
  },
  {
    id: 61,
    title: 'Português (Brasil)',
    value: 'pt_BR',
    href: '/pt_BR',
  },
  {
    id: 111,
    title: 'Español (México)',
    value: 'es_MX',
    href: '/es_MX',
  },
  {
    id: 34,
    title: 'हिंदी',
    value: 'hi',
    href: '/hi',
  },
];

export const menuTitles = {
  en: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  de_DE: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  fr_FR: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  es_MX: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  fr_CA: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  es_ES: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  pt_BR: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
  hi: {
    level1: 'Love Stories',
    level2: 'All Stories',
  },
};
